<template>
  <Modal
    v-model="_value"
    width="500"
    title="查看/修改收入项信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="loginForm" :model="incomeInfo" :rules="rules" style="display: inline;">
      <FormItem prop="name">
        <label style="display: inline-block; width: 60px;">收入项名称</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="incomeInfo.name" placeholder="请输入收入项名称">
        </Input>
      </FormItem>
      <FormItem prop="payer">
        <label style="display: inline-block; width: 60px;">支付方名称</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="incomeInfo.payer" placeholder="请输入支付方名称">
        </Input>
      </FormItem>
      <FormItem prop="total">
        <label style="display: inline-block; width: 60px;">收款总额</label>
        <InputNumber style="display: inline-block; width: 200px;" :disabled="!modify" v-model="incomeInfo.total" placeholder="请输入收款总额">
        </InputNumber>
      </FormItem>
      <FormItem prop="payType">
        <label style="display: inline-block; width: 60px;">支付方式</label>
        <Select style="display: inline-block; width: 200px;" :disabled="!modify" v-model="incomeInfo.payType">
          <Option v-for="item in payType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="occurrenceDatetime">
        <label style="display: inline-block; width: 60px;">收款时间</label>
        <DatePicker style="display: inline-block; width: 400px;" :disabled="!modify" v-model="incomeInfo.occurrenceDatetime" type="date" placeholder="请输入收款时间"></DatePicker>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'IncomeDetailModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      totalRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '收款总额不能为空', trigger: 'blur' }
          ]
        }
      },
      payTypeRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '支付类型不能为空', trigger: 'blur' }
          ]
        }
      },
      occurrenceDatetimeRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '收款时间不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        modify: false,
        payType:[
          {label:'银行转账',value:1},
          {label:'现金支付',value:2},
          {label:'网络支付',value:3},
        ],
        incomeInfo: {
          id:null,
          name:null,
          payer:null,
          total:0,
          payType:1,
          occurrenceDatetime:null
        }
      }
    },
    methods: {
      ...mapActions([
        'IncomeServ_GetDetail',
        'IncomeServ_ModifyObj'
      ]),
      modifyChange(status) {
        if (status === false) {
          this.$Modal.confirm({
            title: '确认修改收入项信息',
            content: '<p>确认修改收入项信息</p>',
            onOk: () => {
              store.dispatch('IncomeServ_ModifyObj', {
                params: this.incomeInfo
              }).then(() => {
                this.$Message.success('修改成功')
                this.$emit('on-success')
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
              });
            },
            onCancel: () => {
              let incomeId = this._initValue
              store.dispatch('IncomeServ_GetDetail', {
                params: {id: incomeId}
              }).then(() => {
                this.incomeInfo = store.getters.get_Income_GetDetailResult;
              }).catch(err => {
                this.$Message.error(err)
              })
            }
          });
        }
      },
      visibleChange(val) {
        if (val) {
          this.id = null
          this.incomeInfo.name = null
          this.incomeInfo.payer = null
          this.incomeInfo.total = 0
          this.incomeInfo.payType = 1
          this.incomeInfo.occurrenceDatetime = null
          let incomeId = this._initValue
          if (incomeId) {
            store.dispatch('IncomeServ_GetDetail', {
              params: {id: incomeId}
            }).then(() => {
              this.incomeInfo = store.getters.get_Income_GetDetailResult;
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules() {
        return {
          total: this.totalRules,
          payType: this.payTypeRules,
          occurrenceDatetime: this.occurrenceDatetimeRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
